module.exports = __webpack_public_path__ + "assets/img/covers.89c4263c.jpg";